<template>
	<inertia-head title="Investor Zoom Attendees" />
	<div class="bg-primary">
		<div class="bg-black-25">
			<div class="content text-center">
				<div class="py-0">
					<h1 class="fw-bold text-white mb-2">Investor Zoom Attendees</h1>
					<h2 class="h4 fw-normal text-white-75 fs-sm">Investor Zoom Attendees Management List</h2>
				</div>
			</div>
		</div>
	</div>

	<div class="content">
		<div class="mb-2 h2 text-center">
			{{event.investor_zoom_topic}}
		</div>
		<div class="mb-2">
			<inertia-link
				:href="route('admin.investor-zoom-events')"
				class="btn btn-secondary btn-sm"
			>
				<i class="si si-action-undo me-1"></i> Go Back
			</inertia-link>
		</div>
		<div class="block border-bottom">
			<div class="block-content">
				<form @submit.prevent="searchAttendees">
					<div class="row">
						<div class="col-md-5 mb-4">
							<div class="input-group">
								<span class="input-group-text">Date</span>
								<select v-model="form.start_datetime" class="form-select">
									<option value="">ALL</option>
									<option v-for="(edate,e_index) in event.zoom_dates" :value="edate.start_datetime">{{edate.start_date_format}} {{edate.start_time}}</option>
								</select>
							</div>
						</div>
						<div class="col-md-7 mb-4">
							<div class="input-group">
								<input v-model="form.search" type="text" id="search" name="search" class="form-control" placeholder="Search" />
								<span class="input-group-btn">
									<button
										type="submit"
										class="btn btn-secondary"
										:disabled="!form.isDirty || form.processing"
									>
										<i class="fa fa-search me-1"></i>Display
									</button>
								</span>
							</div>
						</div>
					</div>
				</form>
			</div>
		</div>
		<pagination :collections="attendees" />
		<div class="block mb-1">
			<div class="block-content block-content-full">
				<div class="fw-bold">TOTAL RECORD: {{attendees.data.length>0?attendees.data[0].total:0}}</div>
				<div class="table-responsive">
					<table class="table fs-sm">
						<thead>
							<tr>
								<th>#</th>
								<th>Schedule</th>
								<th>Attendee</th>
								<th>Mobile#</th>
								<th>Affiliate</th>
								<th>Created</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(attendee,e_index) in attendees.data">
								<div>{{attendee.iz_no}}</div>
								<td nowrap="">{{attendee.start_date_format}}
									<div><sub>{{attendee.start_time_format}} - {{attendee.end_time_format}}</sub></div>
								</td>
								<td>{{attendee.fname}} {{attendee.lname}}
									<div class="text-info">{{attendee.email}}</div>
								</td>
								<td><span class="badge bg-info">{{attendee.country_code}}</span> {{attendee.mobile}}</td>
								<td>{{attendee.affiliate}}</td>
								<td>{{attendee.created_at}}</td>
							</tr>
							<tr v-if="attendees.data.length<=0">
								<td colspan="6" class="text-center fw-bold text-muted">No Attendees Found</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</div>
		<div class="mt-3">
			<pagination :collections="attendees" />
		</div>
	</div>


</template>

<script>
	import { onMounted, watch, ref, reactive } from 'vue';
	import { useForm } from '@inertiajs/inertia-vue3';
	import AuthLayout from '../../../Layouts/AuthLayout';
	import { createToaster } from '@meforma/vue-toaster';
	import { Inertia } from '@inertiajs/inertia';

	export default{
		layout: AuthLayout,
		props: {
			event				: Object,
			attendees			: Object,
			start_datetime		: String,
			search				: String,
			errors				: Object,
			api_response 		: Object,
			flash				: Object
		},
		setup(props){

			const toast = createToaster();

			const form = useForm({
				search 			: props.search,
				start_datetime 	: props.start_datetime,
			})


			const searchAttendees = () => {

				Inertia.get(props.event.investor_zoom_event_uuid,{
					search 			: form.search,
					start_datetime 	: form.start_datetime
				})
			}

			const viewAttendee = (_event_uuid)=>{
				Inertia.get("investor-zoom-events/attendees/"+_event_uuid);
			}


			return{
				toast,
				form,
				viewAttendee,
				searchAttendees
			}

		}
	}

</script>